import React, { Component } from 'react'
import {findDOMNode } from 'react-dom'

class PopupFrame extends Component {

    componentDidMount() {
        findDOMNode(this).scrollIntoView({
            block: "center", 
            inline: "nearest",
            behavior: "smooth"
        })
    }

    render () {
        return (
            <div className={this.props.className}>

                <div 
                    onClick={this.props.onClose}
                    className="tickets-popup-back"
                    >&nbsp;</div>

                <div className='tickets-popup-frame'>

                    <div className='tickets-popup-title'>{this.props.title}</div>

                    <div 
                        className='tickets-popup-close-btn'
                        onClick={this.props.onClose}>+</div>

                    {this.props.children}

                    <div className="tickets-bottom-filler"></div>
                </div>
            </div>
        )
    }
}

export default PopupFrame